import { useState } from 'react'
import {ArrowRight, Bell, FileSpreadsheet, Layers} from 'lucide-react'

const PERKS = [
  { icon: Bell, label: 'Multi-cloud alerts', sub: 'Threshold-based' },
  { icon: FileSpreadsheet, label: 'Cost planning sheets', sub: 'Excel · Sheets' },
  { icon: Layers, label: 'FinOps architecture', sub: 'Custom advisory' },
]

function CtaBlock() {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!email.includes('@')) return
    setSubmitted(true)
    setTimeout(() => setSubmitted(false), 4000)
    setEmail('')
  }

  return (
    <section className="relative overflow-hidden rounded-2xl border border-[#1F2A44] bg-gradient-to-br from-[#0E1525] via-[#0B0F1C] to-[#0A1626]">
      <div className="absolute inset-0 cosmic-grid opacity-50 pointer-events-none"></div>
      <div className="absolute -top-32 -right-32 w-96 h-96 bg-cyan-500/10 blur-3xl rounded-full pointer-events-none"></div>
      <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-emerald-500/8 blur-3xl rounded-full pointer-events-none"></div>

      <div className="relative grid lg:grid-cols-5 gap-8 p-7 md:p-10">
        <div className="lg:col-span-3">
          <span className="inline-flex items-center gap-2 text-[10px] font-mono uppercase tracking-[0.18em] text-cyan-400 bg-cyan-500/[0.06] border border-cyan-500/20 rounded-full px-3 py-1 mb-5">
            <span className="w-1 h-1 rounded-full bg-cyan-400"></span>
            For FinOps & Platform Teams
          </span>
          <h3 className="text-2xl md:text-3xl font-bold text-slate-100 tracking-tight leading-tight mb-3">
            Stop reverse-engineering<br />
            <span className="gradient-text">native cloud invoices.</span>
          </h3>
          <p className="text-[14px] text-slate-400 leading-relaxed max-w-lg mb-6">
            Get advanced multi-cloud cost alerts, monthly planning sheets benchmarked against your real workloads, and bespoke FinOps architecture reports — delivered straight to your stack.
          </p>

          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2 max-w-lg">
            <input
              type="email"
              required
              placeholder="you@company.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="flex-1 bg-[#0B0F1C] border border-[#1F2A44] focus:border-cyan-500/50 focus:outline-none rounded-lg px-4 py-3 text-[14px] text-slate-100 placeholder-slate-600 font-mono transition-colors"
            />
            <button
              type="submit"
              className="group inline-flex items-center justify-center gap-2 bg-gradient-to-r from-cyan-400 to-emerald-400 hover:from-cyan-300 hover:to-emerald-300 text-[#070B14] font-semibold text-[13px] tracking-tight rounded-lg px-5 py-3 transition-all shadow-[0_4px_24px_-4px_rgba(56,225,255,0.4)]"
            >
              Request access
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
            </button>
          </form>
          {submitted && (
            <div className="mt-3 text-[12px] text-emerald-400 font-mono animate-float-up">
              ✓ Request received — we will reach out within 24h.
            </div>
          )}
          <p className="mt-3 text-[11px] text-slate-600 font-mono">
            No spam. SOC2-ready. Unsubscribe anytime.
          </p>
        </div>

        <div className="lg:col-span-2 grid gap-3">
          {PERKS.map(p => (
            <div key={p.label} className="flex items-center gap-3 p-4 rounded-xl bg-[#0B0F1C]/60 border border-[#1F2A44] hover:border-cyan-500/30 transition-colors">
              <div className="w-10 h-10 rounded-lg bg-cyan-500/[0.08] border border-cyan-500/20 flex items-center justify-center shrink-0">
                <p.icon className="w-4 h-4 text-cyan-300" />
              </div>
              <div>
                <div className="text-[13px] font-semibold text-slate-200">{p.label}</div>
                <div className="text-[11px] font-mono text-slate-500 mt-0.5">{p.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default CtaBlock
